module.exports = __webpack_public_path__ + "img/orange-alert-icon.139ad266.svg";